"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserRoleType = void 0;
const Organization_1 = require("../types/Organization");
const isUserRoleType = (value) => {
    return Organization_1.USER_ROLE_TYPES.some((roleType) => roleType === value);
};
exports.isUserRoleType = isUserRoleType;
//# sourceMappingURL=organization.js.map